import { ErrorHandler, Injector, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './error.service';
import { LoggingService } from './logging.service';
import { WipperozAlertService } from './alert.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse) {
    const errorService = this.injector.get(ErrorService);
    const logger = this.injector.get(LoggingService);
    const notifier = this.injector.get(WipperozAlertService);

    let message;
    let stackTrace;

    if (error instanceof HttpErrorResponse) {
      // Server Error
      message = errorService.getServerMessage(error);
      stackTrace = errorService.getServerStack(error);
      notifier.error(message, false, 10000);
      if (stackTrace !== undefined) {
        console.error(stackTrace);
      }
      logger
        .logError('GlobalErrorHandlerService - HttpErrorResponse', message, stackTrace)
        .then((value: any) => {
          console.warn(value);
        })
        .catch((err: any) => {
          console.error(err);
        });
    } else {
      // Client Error
      message = errorService.getClientMessage(error);
      stackTrace = errorService.getClientStack(error);
      notifier.error(message, false, 10000);
      if (stackTrace !== undefined) {
        console.error(stackTrace);
      }
      logger
        .logError('GlobalErrorHandlerService - Client Error', message, stackTrace)
        .then((value: any) => {
          console.warn(value);
        })
        .catch((err: any) => {
          console.error(err);
        });
    }
  }
}
